import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=e8df8874&lang=pug"
import script from "./ClientSelect.vue?vue&type=script&lang=js"
export * from "./ClientSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClientSelect: require('/home/docker/code/frontend/components/ClientSelect.vue').default})
